import { TableColumn, TableConfig } from "../../../../@shared/models/table.models";

export const CONSUMPTION_TABLE_COLUMNS: TableColumn[] = [
    {
        field: 'rowIndex',
        header: 'S. No.',
        type: 'text',
        width: '100px'
    },
    {
        field: 'date',
        header: 'Date',
        type: 'text'
    },
    {
        field: 'totalTokens',
        header: 'Token',
        type: 'text'
    }
];

export const CONSUMPTION_TABLE_CONFIG: TableConfig = {
    selectable: false,
    paginator: true,
    rows: 10,
    rowsPerPageOptions: [5, 10, 20, 50],
    scrollable: true,
    scrollHeight: "100%",
    loading: false,
    emptyMessage: "No data available",
    globalFilter: false,
    responsive: true
};

